export const artifactTypeEnum = {
  SW_PACKAGE: 'SW_PACKAGE',
  TEMPLATE: 'TEMPLATE',
  DATA_FILE: 'DATA_FILE',
} as const;
export type ArtifactTypeEnum = (typeof artifactTypeEnum)[keyof typeof artifactTypeEnum];

export const artifactComponentTypeEnum = {
  APPLICATION: 'APPLICATION',
  OS: 'OS',
  OTHER: 'OTHER',
  RESOURCE: 'RESOURCE',
  SYSTEM_PACKAGE: 'SYSTEM_PACKAGE',
} as const;
export type ArtifactComponentTypeEnum = (typeof artifactComponentTypeEnum)[keyof typeof artifactComponentTypeEnum];

export interface ArtifactResource {
  readonly checksum: string;
  readonly componentType: ArtifactComponentTypeEnum;
  readonly id: string;
  readonly mimeType: string;
  readonly name: string;
  readonly size: number;
  readonly type: ArtifactTypeEnum;
}

export interface ArtifactRequest {
  readonly artifactName: string;
  readonly checksum: string;
  readonly type: ArtifactTypeEnum;
  readonly file: Blob;
  readonly componentType: ArtifactComponentTypeEnum;
}

export interface ErrorWithPlaceholdersInstance {
  readonly pointer?: string;
}
export interface ErrorWithPlaceholdersPlaceholder {
  readonly key: string;
  readonly value: string;
}
export interface ErrorWithPlaceholders {
  readonly details?: string;
  readonly instance?: ErrorWithPlaceholdersInstance;
  readonly title: string;
  readonly type: string;
  readonly placeholders?: ErrorWithPlaceholdersPlaceholder[];
}
